import React, { Component, ReactElement } from 'react'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { ForgotPassword } from '../Components/Organisms/ForgotPassword/Main/ForgotPassword'
import { LanguageContextProvider } from '../../React/Common/Contexts'
import { WelcomeContainer } from '../Components/Organisms/WelcomeContainer/WelcomeContainer'
import { RouteGuard } from '../Guards/RouteGuard'
import { useDisableUserInfoErrors } from '../../React/Common/Hooks/useDisableUserInfoErrors'

@Route(RouteID.FORGOT_PASSWORD)
export class ForgotPasswordPage extends Component {
    render(): ReactElement {
        useDisableUserInfoErrors()

        return (
            <RouteGuard route={RouteID.FORGOT_PASSWORD}>
                <LanguageContextProvider>
                    <WelcomeContainer>
                        <ForgotPassword />
                    </WelcomeContainer>
                </LanguageContextProvider>
            </RouteGuard>
        )
    }
}
